import { defineStyle } from '@chakra-ui/react';

const style = defineStyle({
  root: {
    flexDirection: 'column',
    py: {
      base: '48px',
      lg: '96px',
      '2xl': '128px',
    },
    gap: {
      base: '64px',
      lg: '152.96px',
    },
  },
});

export default style;
